import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
import { parseEntityId } from '../entity'

class ComunicacionEmbarque {
  static adaptToBackend (datosCaratula = {}) {
    const {
      fechaArribo,
      fechaZarpada,
      buque,
      agencia,
      giro,
      buqueAceitero,
      cereal
    } = datosCaratula

    return {
      fechaDeArribo: fechaArribo,
      fechaDeZarpada: fechaZarpada,
      // buque: parseEntityId(String(buque).split('[')[0]).substring(1, 8),
      buque: buque.nombreCorto,
      agenciaMaritima: parseEntityId(agencia) || null,
      giro: giro,
      aceitero: buqueAceitero,
      cereal: cereal
    }
  }

  static async getDatosBuque (nombre) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/buque?r=` +
    `{"clave":{"nombre_corto":"${nombre}"}}`)

    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }

  static altaCaratula (caratulaValues = {}) {
    const valores = this.adaptToBackend(caratulaValues)
    const axios = getAxiosInstance()
    const promise = axios.post(`/caratula`, { valores: { ...valores } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static modificarCaratula (caratulaValues = {}, id) {
    const valores = this.adaptToBackend(caratulaValues)
    const axios = getAxiosInstance()
    const promise = axios.put(`/caratula`, { valores: { ...valores }, clave: { id } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static regresarCaratulaEstadoInactiva (id) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/caratula`,
      `{"valores": {"identificador_aduana": null, "observaciones": null}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static eliminarCaratula (id) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`/caratula?r=` +
      `{"clave": {"id": "${id}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async getCaratula (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_caratula_id?r=` +
    `{"clave":{"id":"${id}"}}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }

  static async getExportadorPorCaratula (caratula) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/mapeo_caratula_exportador?r=` +
    `{"clave":{"caratula": ${caratula}}}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data
  }

  static async getHistorialCaratula (identificadorAduana) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/caratula_historial?r=` +
    `{"clave":{"identificador_aduana":"${identificadorAduana}"}, "orden":["d:fecha"]}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data
  }

  static getCaratulasActivas () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_caratulas_activas?r=` +
    `{"orden": ["d:id"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static getCaratulasInactivas () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_caratulas_inactivas?r=` +
    `{"orden": ["d:id"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static getUltimaCaratulaInactiva () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_caratulas_inactivas?r=` +
    `{"limite":1, "orden": ["d:id"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static getCaratulasFinalizadas () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_caratulas_finalizadas?r=` +
    `{"orden": ["d:fecha_de_zarpada"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async getCaratulaInactiva (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_caratulas_inactivas_id?r=` +
    `{"clave":{"id":"${id}"}}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }

  static async getCaratulaActiva (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_caratulas_activas_id?r=` +
    `{"clave":{"id":"${id}"}}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data[0]
  }

  static getCaratulasActivasConEstado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_caratulas_activas_con_estado?r=` +
    `{"orden": ["d:id"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static agregarExportadorCaratula (caratula, exportador) {
    const axios = getAxiosInstance()
    const promise = axios.post(`/mapeo_caratula_exportador`,
      `{"valores":{"caratula": ${caratula}, "exportador": ${exportador}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static consultaExportadorCaratula (caratula) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_caratula_exportador?r=` +
    `{"clave":{"caratula": ${caratula}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static consultaCaratulasActivasConExportador (exportador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_caratulas_activas_con_exportador?r=` +
    `{"clave":{"exportador": ${exportador}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static consultaCaratulasInactivasConExportador (exportador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_caratulas_inactivas_con_exportador?r=` +
    `{"clave":{"exportador": ${exportador}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static consultaCaratulasFinalizadasConExportador (exportador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_caratulas_finalizadas_con_exportador?r=` +
    `{"clave":{"exportador": ${exportador}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static listadoExportadorCaratula () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/listado_caratula_exportador`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static listadoExportadoresCaratulasInactivas () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/exportadores_caratulas_inactivas`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static listadoExportadoresCaratulasActivas () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/exportadores_caratulas_activas`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static listadoExportadoresCaratulasFinalizadas () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/exportadores_caratulas_finalizadas`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static eliminarExportadorCaratula (caratula) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`/mapeo_caratula_exportador?r=` +
    `{"clave":{"caratula": ${caratula}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static registrarCaratula (identificadorBuque, codigoLugarOperativo, fechaArribo, fechaZarpada, nombreMedioTransporte, numeroViaje) {
    const axios = getAxiosInstance()
    const promise = axios.get(`registrar_caratula?r=` +
    `{"parametros": {"identificador_buque": ${identificadorBuque}, "codigo_lugar_operativo": "${codigoLugarOperativo}",
    "fecha_arribo": "${fechaArribo}", "fecha_zarpada": "${fechaZarpada}", "nombre_medio_transporte": "${nombreMedioTransporte}",
    "numero_viaje": "${numeroViaje}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static rectificarCaratula (identificadorBuque, codigoLugarOperativo, fechaArribo, fechaZarpada, nombreMedioTransporte, identificadorCaratula) {
    const axios = getAxiosInstance()
    const promise = axios.get(`rectificar_caratula?r=` +
    `{"parametros": {"identificador_buque": ${identificadorBuque}, "codigo_lugar_operativo": "${codigoLugarOperativo}",
    "fecha_arribo": "${fechaArribo}", "fecha_zarpada": "${fechaZarpada}", "nombre_medio_transporte": "${nombreMedioTransporte}",
    "identificador_caratula": "${identificadorCaratula}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static anularCaratula (identificadorCaratula) {
    const axios = getAxiosInstance()
    const promise = axios.get(`anular_caratula?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static updateCaratulaIdAduana (id, idAduana) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/caratula`,
      `{"valores": {"identificador_aduana": "${idAduana.trim()}"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static updateCaratulaFechaDeZarpada (fechaDeZarpada, id) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/caratula`,
      `{"valores": {"fecha_de_zarpada": "${fechaDeZarpada}"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static updateCaratulaAnulada (id) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/caratula`,
      `{"valores": {"anulada": "TRUE"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static updateCoemIdAduana (id, idAduana) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/coem`,
      `{"valores": {"identificador_aduana": "${idAduana.trim()}"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static solicitarCambioBuque (identificadorCaratula, identificadorBuque, nombreMedioTransporte) {
    const axios = getAxiosInstance()
    const promise = axios.get(`solicitar_cambio_buque?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}", "identificador_buque": ${identificadorBuque},
    "nombre_medio_transporte": "${nombreMedioTransporte}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static solicitarCambioFechas (identificadorCaratula, fechaArribo, fechaZarpada, descripcionMotivo) {
    const axios = getAxiosInstance()
    const promise = axios.get(`solicitar_cambio_fechas?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}", "fecha_arribo": "${fechaArribo}",
    "fecha_zarpada": "${fechaZarpada}", "descripcion_motivo": "${descripcionMotivo}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static solicitarAnulacionCoem (identificadorCaratula, identificadorCoem) {
    const axios = getAxiosInstance()
    const promise = axios.get(`solicitar_anulacion_coem?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}", "identificador_coem": "${identificadorCoem}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static solicitarNoABordo (identificadorCaratula, identificadorCoem, identificadorDeclaracion, descripcionMotivo) {
    const axios = getAxiosInstance()
    const promise = axios.get(`solicitar_no_a_bordo?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}", "identificador_coem": "${identificadorCoem}",
    "identificador_declaracion": "${identificadorDeclaracion}", "descripcion_motivo": "${descripcionMotivo}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static solicitarCambioLOT (identificadorCaratula, codigoLugarOperativo) {
    const axios = getAxiosInstance()
    const promise = axios.get(`solicitar_cambio_lot?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}", "codigo_lugar_operativo": "${codigoLugarOperativo}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static solicitarCierreCargaGranel (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`solicitar_cierre_carga_granel?r=` +
    `{"parametros": {"id_caratula": "${id}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static registrarCoem (identificadorCaratula, identificadorDeclaracion, cuitAta, codigoEmbalaje, peso) {
    const axios = getAxiosInstance()
    const promise = axios.get(`registrar_coem?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}", "identificador_declaracion": "${identificadorDeclaracion}",
    "cuit_ata": "${cuitAta}", "codigo_embalaje": "${codigoEmbalaje}", "peso": ${peso} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static rectificarCoem (identificadorCaratula, identificadorCoem, identificadorDeclaracion, cuitAta, codigoEmbalaje, peso) {
    const axios = getAxiosInstance()
    const promise = axios.get(`rectificar_coem?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}", "identificador_coem": "${identificadorCoem}",
    "identificador_declaracion": "${identificadorDeclaracion}", "cuit_ata": "${cuitAta}", "codigo_embalaje": "${codigoEmbalaje}", "peso": ${peso} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static anularCoem (identificadorCaratula, identificadorCoem) {
    const axios = getAxiosInstance()
    const promise = axios.get(`anular_coem?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}", "identificador_coem": "${identificadorCoem}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static eliminarCoem (id) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`/coem?r=` +
      `{"clave": {"id": "${id}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static cerrarCoem (identificadorCaratula, identificadorCoem) {
    const axios = getAxiosInstance()
    const promise = axios.get(`cerrar_coem?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}", "identificador_coem": "${identificadorCoem}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static updateCoemAnulada (id) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/coem`,
      `{"valores": {"anulada": "TRUE"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static updateCoemActiva (id) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/coem`,
      `{"valores": {"anulada": "FALSE"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static regresarEstadoAnteriorCoem (idCoem) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/coem`,
      `{"valores": {"identificador_aduana": null, 
      "observaciones": null, "cerrada": "FALSE"},
      "clave": {"id": ${idCoem}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static updateCoemCerrada (id) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/coem`,
      `{"valores": {"cerrada": "TRUE"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static updateBuque (datosBuque) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackendUpdate(datosBuque)
    const promise = axios.put(`/buque`, { valores: { ...valores }, clave: { nombre_corto: datosBuque.nombreCorto } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static async getCoemId (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_coem_id?r=` +
    `{"clave":{"id":"${id}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static async getCoemPorCaratula (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_coem_por_caratula?r=` +
    `{"clave":{"caratula":"${id}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async getCoemAnuladasPorCaratula (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_coem_anulada_por_caratula?r=` +
    `{"clave":{"caratula":"${id}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async getCoemCerradosPorCaratula (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_coem_cerrada_por_caratula?r=` +
    `{"clave":{"caratula":"${id}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static async getHistorialCoem (identificadorAduana) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/coem_historial?r=` +
    `{"clave":{"identificador_aduana":"${identificadorAduana}"}, "orden":["d:fecha"]}`)
    const lrsAdap = await promise
    const response = await lrsAdapter(lrsAdap)
    return response.data
  }

  static altaCoem (coemValues = {}) {
    const codigoEmbalaje = 32 // Granel
    const axios = getAxiosInstance()
    const promise = axios.post(`/coem`,
      `{"valores": {"caratula": "${coemValues.caratula}", "identificador_declaracion": "${coemValues.identificadorDeclaracion.toUpperCase()}",
    "peso": "${coemValues.peso}", "ata": "${coemValues.agenciaMaritima}", "codigo_embalaje": "${codigoEmbalaje}", "item": "1",
    "exportador": ${coemValues.exportador}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static modificarCoem (coemValues = {}) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/coem`,
      `{"valores": {"identificador_declaracion": "${coemValues.identificadorDeclaracion.toUpperCase()}", 
      "peso": ${coemValues.peso}, "cierre_cumplido": "${coemValues.cierreCumplidoSwitch}",
      "item": 1, "peso_embarcado": ${coemValues.cantidadReal}, "fecha_de_embarque": "${coemValues.fechaEmbarque}",
      "peso_embarcado_item2": ${coemValues.cantidadReal2}, "peso_embarcado_item3": ${coemValues.cantidadReal3},
      "peso_embarcado_item4": ${coemValues.cantidadReal4},  "exportador": ${coemValues.exportador}}, 
      "clave": {"id": ${coemValues.idCoem}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static altaCode (id, idAduana, peso) {
    const axios = getAxiosInstance()
    const promise = axios.post(`/code`,
      `{"valores": {"identificador_aduana": "${idAduana.toUpperCase()}",
      "peso_final": ${peso}, "caratula": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static deleteCode (id) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`/eliminar_code_por_caratula?r=` +
    `{"clave": {"caratula": "${id}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static getPesosTotales (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_peso_total_embarcado?r=` +
    `{"parametros": {"id_caratula": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }

  static getCoems () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_coem?r=` +
    `{"orden": ["id"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static addHistoryCaratula (identificadorAduana, accion) {
    const axios = getAxiosInstance()
    const promise = axios.post(`/caratula_historial`,
      `{"valores": {"identificador_aduana": "${identificadorAduana.trim()}",
      "descripcion": "${accion}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static addHistoryCoem (identificadorAduana, accion) {
    const axios = getAxiosInstance()
    const promise = axios.post(`/coem_historial`,
      `{"valores": {"identificador_aduana": "${identificadorAduana.trim()}",
      "descripcion": "${accion}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static ultimaAccionCaratula (id, accion) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/caratula`,
      `{"valores": {"observaciones": "${accion}"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static ultimaAccionCoem (id, accion) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/coem`,
      `{"valores": {"observaciones": "${accion}"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static consultaEstadosCoem (identificadorCaratula) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_estados_coem?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static consultaSolicitudes (identificadorCaratula) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_solicitudes?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static consultaNoAbordo (identificadorCaratula) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_no_abordo?r=` +
    `{"parametros": {"identificador_caratula": "${identificadorCaratula}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static exportadoresActivos () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/exportador?r=` +
    `{"clave":{"activo":"TRUE"}, "orden":["d:razon_social"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }
}

export default ComunicacionEmbarque
